import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  UpdateSchemeMutation as UpdateSchemeMutationType,
  UpdateSchemeMutationVariables,
} from "./__generated__/UpdateSchemeMutation";

const UpdateSchemeMutation = loader("./UpdateSchemeMutation.gql");

type UpdateSchemeMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: UpdateSchemeMutationType) => void;
}) => ReactElement;

export const UpdateSchemeMutationProvider: UpdateSchemeMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<UpdateSchemeMutationType, UpdateSchemeMutationVariables>(
    UpdateSchemeMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
